/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkDocxOutputFormatEnum } from '../models/work-docx-output-format-enum';
import { WorkGenerateFromTemplateV2Dto } from '../models/work-generate-from-template-v-2-dto';

@Injectable({ providedIn: 'root' })
export class WorkDocumentsGeneratorV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `documentsGeneratorV2ControllerGenerateFromTemplate()` */
  static readonly DocumentsGeneratorV2ControllerGenerateFromTemplatePath = '/v2/documents-generator';

  /**
   * Required permissions: documents:read, projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsGeneratorV2ControllerGenerateFromTemplate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsGeneratorV2ControllerGenerateFromTemplate$Response(
    params: {
      format: WorkDocxOutputFormatEnum;
      body: WorkGenerateFromTemplateV2Dto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<{
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsGeneratorV2Service.DocumentsGeneratorV2ControllerGenerateFromTemplatePath, 'post');
    if (params) {
      rb.query('format', params.format, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * Required permissions: documents:read, projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsGeneratorV2ControllerGenerateFromTemplate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsGeneratorV2ControllerGenerateFromTemplate(
    params: {
      format: WorkDocxOutputFormatEnum;
      body: WorkGenerateFromTemplateV2Dto
    },
    context?: HttpContext
  ): Observable<{
}> {
    return this.documentsGeneratorV2ControllerGenerateFromTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /** Path part for operation `documentsGeneratorV2ControllerGenerateFromTemplateForOfficeV4()` */
  static readonly DocumentsGeneratorV2ControllerGenerateFromTemplateForOfficeV4Path = '/v2/documents-generator/v4';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsGeneratorV2ControllerGenerateFromTemplateForOfficeV4()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsGeneratorV2ControllerGenerateFromTemplateForOfficeV4$Response(
    params: {
      format: WorkDocxOutputFormatEnum;
      body: WorkGenerateFromTemplateV2Dto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<{
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsGeneratorV2Service.DocumentsGeneratorV2ControllerGenerateFromTemplateForOfficeV4Path, 'post');
    if (params) {
      rb.query('format', params.format, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsGeneratorV2ControllerGenerateFromTemplateForOfficeV4$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentsGeneratorV2ControllerGenerateFromTemplateForOfficeV4(
    params: {
      format: WorkDocxOutputFormatEnum;
      body: WorkGenerateFromTemplateV2Dto
    },
    context?: HttpContext
  ): Observable<{
}> {
    return this.documentsGeneratorV2ControllerGenerateFromTemplateForOfficeV4$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

}
